<template>
  <c-row>
    <c-col col="12" md="6">
      <c-card>
        <c-card-header>
          <c-icon name="cil-justify-center" />
          <strong>Bootstrap Alert</strong>
          <div class="card-header-actions">
            <a
              href="https://coreui.io/vue/docs/components/alert"
              class="card-header-action"
              rel="noreferrer noopener"
              target="_blank"
            >
              <small class="text-muted">docs</small>
            </a>
          </div>
        </c-card-header>
        <c-card-body>
          <div>
            <p />
            <c-alert show color="primary">Primary Alert</c-alert>
            <c-alert show color="secondary">Secondary Alert</c-alert>
            <c-alert show color="success">Success Alert</c-alert>
            <c-alert show color="danger">Danger Alert</c-alert>
            <c-alert show color="warning">Warning Alert</c-alert>
            <c-alert show color="info">Info Alert</c-alert>
            <c-alert show color="light">Light Alert</c-alert>
            <c-alert show color="dark">Dark Alert</c-alert>
          </div>
        </c-card-body>
      </c-card>
    </c-col>
    <c-col col="12" md="6">
      <c-card>
        <c-card-header>
          <c-icon name="cil-justify-center" />
          Alert
          <small>
            use
            <code>.alert-link</code>
            to provide links
          </small>
        </c-card-header>
        <c-card-body>
          <div>
            <c-alert show color="primary">
              Primary Alert with
              <a href="#" class="alert-link">an example link</a>
              .
            </c-alert>
            <c-alert show color="secondary">
              Secondary Alert with
              <a href="#" class="alert-link">an example link</a>
              .
            </c-alert>
            <c-alert show color="success">
              Success Alert with
              <a href="#" class="alert-link">an example link</a>
              .
            </c-alert>
            <c-alert show color="danger">
              Danger Alert with
              <a href="#" class="alert-link">an example link</a>
              .
            </c-alert>
            <c-alert show color="warning">
              Warning Alert with
              <a href="#" class="alert-link">an example link</a>
              .
            </c-alert>
            <c-alert show color="info">
              Info Alert with
              <a href="#" class="alert-link">an example link</a>
              .
            </c-alert>
            <c-alert show color="light">
              Light Alert with
              <a href="#" class="alert-link">an example link</a>
              .
            </c-alert>
            <c-alert show color="dark">
              Dark Alert with
              <c-link href="#" class="alert-link">an example link</c-link>
              .
            </c-alert>
          </div>
        </c-card-body>
      </c-card>
    </c-col>
    <c-col col="12" md="6">
      <c-card>
        <c-card-header>
          <c-icon name="cil-justify-center" />
          Alerts
          <small>with additional content</small>
        </c-card-header>
        <c-card-body>
          <c-alert show color="success">
            <h4 class="alert-heading">Well done!</h4>
            <p>
              Aww yeah, you successfully read this important alert message. This example text is going to run a bit
              longer so that you can see how spacing within an alert works with this kind of content.
            </p>
            <hr />
            <p class="mb-0">
              Whenever you need to, be sure to use margin utilities to keep things nice and tidy.
            </p>
          </c-alert>
        </c-card-body>
      </c-card>
    </c-col>
    <c-col col="12" md="6">
      <c-card>
        <c-card-header>
          <c-icon name="cil-justify-center" />
          Alerts
          <small>dismissible</small>
        </c-card-header>
        <c-card-body>
          <c-alert color="secondary" close-button :show.sync="alert1">
            Dismissible Alert!
          </c-alert>

          <c-alert color="secondary" :show.sync="alert2" class="alert-dismissible">
            Dismissible Alert with custom button!
            <c-button
              class="position-absolute"
              color="secondary"
              style="right:10px;top: 50%;transform: translateY(-50%);"
              @click="alert2 = false"
            >
              Close
            </c-button>
          </c-alert>
          <c-button color="info" class="m-1" @click="showDismissibleAlerts">
            Show dismissible alerts
          </c-button>
        </c-card-body>
      </c-card>
      <c-card>
        <c-card-header>
          <c-icon name="cil-justify-center" />
          Alerts
          <small>auto dismissible</small>
        </c-card-header>
        <c-card-body>
          <div>
            <c-alert :show.sync="dismissCountDown" close-button color="warning" fade>
              Alert will dismiss after
              <strong>{{ dismissCountDown }}</strong>
              seconds...
            </c-alert>

            <c-alert :show.sync="dismissCountDown" close-button color="info">
              Alert will dismiss after {{ dismissCountDown }} seconds...
              <c-progress color="info" :max="dismissSecs" :value="dismissCountDown" height="4px" />
            </c-alert>
            <c-button color="info" class="m-1" @click="showAlert">
              Show alert with timer
            </c-button>
          </div>
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</template>

<script>
export default {
  name: 'Alerts',
  data() {
    return {
      dismissSecs: 10,
      dismissCountDown: 10,
      alert1: true,
      alert2: true,
    };
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    showDismissibleAlerts() {
      ['alert1', 'alert2'].forEach((alert) => (this[alert] = true));
    },
  },
};
</script>
